import React from "react";
import SelectAny from "components/select/select-any";

export default function ExpertiseInput(props) {
    return (
        <SelectAny
            {...props}
            collection="openings"
            field="expertise"
            placeholder="Select expertise"
        />
    );
}
